<template>
  <button
    class="add-card-toolbar-icon pt flex items-center justify-center"
    @click="props.effect"
  >
    <em
      class="custom-icons page-toolbar mr-1 group-hover:bg-icon-hover"
      :style="getCustomIconStyle(iconPath('plus2'))"
    />
    {{ translate('card') }}
  </button>
</template>

<script setup lang="ts">
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';

const props = defineProps<{
  effect: CallableFunction;
}>();

const { iconPath, getCustomIconStyle } = useCustomIcon();

const { translate } = useTranslate();
</script>

<style lang="scss" scoped>
button {
  &.add-card-toolbar-icon {
    @apply text-text-default px-2;
  }
}
</style>
